// Triple J Bali — client-side cart (localStorage) + WhatsApp helpers
import { SITE } from "../data/site";
import { formatIDR } from "../data/products";

const KEY = "tjb_cart_v1";

export const readCart = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
};

export const writeCart = (items) => {
  localStorage.setItem(KEY, JSON.stringify(items));
  window.dispatchEvent(new CustomEvent("tjb-cart-change"));
};

const lineKey = (productId, size, color) =>
  `${productId}__${size || ""}__${color || ""}`;

export const addToCart = (product, { size, color, qty = 1 }) => {
  const items = readCart();
  const k = lineKey(product.id, size, color);
  const idx = items.findIndex((it) => it.key === k);
  if (idx >= 0) {
    items[idx].qty += qty;
  } else {
    items.push({
      key: k,
      productId: product.id,
      name: product.name,
      price: product.price,
      image: product.image,
      size: size || "",
      color: color || "",
      qty,
    });
  }
  writeCart(items);
};

export const updateQty = (key, qty) => {
  const items = readCart()
    .map((it) => (it.key === key ? { ...it, qty: Math.max(1, qty) } : it))
    .filter((it) => it.qty > 0);
  writeCart(items);
};

export const removeItem = (key) => {
  writeCart(readCart().filter((it) => it.key !== key));
};

export const clearCart = () => writeCart([]);

export const cartTotals = (items) => {
  const count = items.reduce((s, it) => s + it.qty, 0);
  const total = items.reduce((s, it) => s + it.qty * it.price, 0);
  return { count, total };
};

// WhatsApp message for whole bag
export const buildCartMessage = (items) => {
  const lines = ["Hi Triple J Bali, I would like to order:", ""];
  items.forEach((it, i) => {
    lines.push(`${i + 1}. ${it.name}`);
    lines.push(`Size: ${it.size || "—"}`);
    lines.push(`Color: ${it.color || "—"}`);
    lines.push(`Qty: ${it.qty}`);
    lines.push(`Price: ${formatIDR(it.price)}`);
    lines.push("");
  });
  const { total } = cartTotals(items);
  lines.push(`Estimated total: ${formatIDR(total)}`);
  lines.push("");
  lines.push("Please confirm availability and payment details. Thank you.");
  return lines.join("\n");
};

// WhatsApp message for single product
export const buildSingleMessage = (product, { size, color } = {}) => {
  return [
    "Hi Triple J Bali, I’m interested in this item:",
    "",
    `Product: ${product.name}`,
    `Size: ${size || "—"}`,
    `Color: ${color || "—"}`,
    `Price: ${formatIDR(product.price)}`,
    "",
    "Please confirm availability. Thank you.",
  ].join("\n");
};

export const waLink = (message) =>
  `${SITE.whatsappUrl}?text=${encodeURIComponent(message)}`;
